import { Image } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

type RemovedImagesDialogProps = {
  open: boolean;
  removedImages: string[];
  handleClose: () => void;
  confirmImageRemoval: () => void;
};

export const RemovedImagesDialog = (props: RemovedImagesDialogProps) => {
  const { open, removedImages, handleClose, confirmImageRemoval } = props;

  const { t } = useTranslation(['groupMessage']);

  const unescapeHTML = (str) => {
    return str.replace(
      /&amp;|&lt;|&gt;|&#39;|&quot;/g,
      (tag) =>
        ({
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&#39;': "'",
          '&quot;': '"',
        }[tag] || tag),
    );
  };

  // RegEx skapar en capturing group "alt" för själva alt-texten
  // Returnera alt-text eller "Okänd bild"
  const getAltText = (img) => {
    const result = /(?:alt=("|'|&quot;)(?<alt>.*?)("|'|&quot;))/gi.exec(img);
    return result?.groups?.alt || t('groupMessage:removeImages.unknownImage');
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>
        {t('groupMessage:removeImages.invalidImagesDialogHeader')}&nbsp;({removedImages.length})
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description' sx={{ mb: 2 }}>
          {t('groupMessage:removeImages.invalidImagesDialogDescription')}
        </DialogContentText>
        {removedImages && removedImages.length > 0 && (
          <GridWrapper>
            {removedImages.map((x, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Grid item xs={6} key={`x${index}`}>
                <Box sx={{ border: '2px solid #333', borderRadius: 1 }}>
                  <Box
                    dangerouslySetInnerHTML={{ __html: unescapeHTML(x) }}
                    sx={{ maxWidth: '100%', '& > img': { maxWidth: '100%', height: 'auto' } }}
                  />
                  <Box sx={{ backgroundColor: '#333', color: '#fff', p: 0.5, display: 'flex', alignItems: 'center' }}>
                    <Image fontSize='small' sx={{ mr: 1 }} />
                    <Typography variant='caption' sx={{ lineHeight: 1 }}>
                      {getAltText(x)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </GridWrapper>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={handleClose} variant='outlined' disableElevation autoFocus>
          {t('groupMessage:removeImages.abortButton')}
        </Button>
        <Button onClick={confirmImageRemoval} color='error' variant='contained' disableElevation>
          {t('groupMessage:removeImages.confirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
